import { t } from 'localization'
import BreadcrumbLink from 'shared/components/BreadcrumbLink'
import { PagesQA } from 'shared/dataAttributes'
import { colors, fonts, media } from 'shared/lib'
import { startCase } from 'shared/utils/formatting-utils'
import styled from 'styled-components'

type FlightClubStoreBreadcrumbsProps = {
  storeName?: string
}

const TP = 'shared.stores.components.FlightClubStoreBreadcrumbs'

const FlightClubStoreBreadcrumbs = ({ storeName }: FlightClubStoreBreadcrumbsProps) => {
  return (
    <>
      <CrumbList>
        <BreadcrumbLink
          dataQa={PagesQA.BreadcrumbFlightClub}
          href="/"
          fontColor={colors.FC2_GREY}
          hasTrailingSlash
          name={t(`${TP}.flightclub`, 'Flight Club')}
        />
        {storeName ?
          <>
            <BreadcrumbLink
              dataQa={PagesQA.BreadcrumbStore}
              href="/storelocator"
              fontColor={colors.FC2_GREY}
              hasTrailingSlash
              name={t(`${TP}.stores`, 'Stores')}
            />
            <CrumbWrapper
              data-testid="breadcrumbStoreName"
              data-qa={PagesQA.BreadcrumbStoreName}
            >
              <LastCrumb>{startCase(storeName.toLowerCase())}</LastCrumb>
            </CrumbWrapper>
          </> :
          <CrumbWrapper
            data-testid="breadcrumbStore"
            data-qa={PagesQA.BreadcrumbStore}
            >
              <LastCrumb>{t(`${TP}.stores`, 'Stores')}</LastCrumb>
          </CrumbWrapper>
        }
      </CrumbList>
    </>
  )
}

const CrumbWrapper = styled.li`
  display: inline-block;
`

const CrumbList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 140%;
`
const LastCrumb = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: ${colors.FC2_GREY};
  ${media.large`
    ${fonts.LINK}
    color: ${colors.FC2_GREY};
    font-weight: normal;
    text-decoration: none;
  `};
`

export default FlightClubStoreBreadcrumbs